
export function getStoreFromUrl(url) {
  try {
    const u = new URL(url);
    return u.searchParams.get("0_store");
  } catch (e) {
    console.error("Invalid URL passed to getStoreFromUrl:", url);
    return null;
  }
}

const STORE_NAMES = {
  "688b8cbab2056ab08208c7b1": "BOON COFFEE ROASTERS CAFE-FALAK",
  "6720fcb3f2db35c9580c8dbe": "BOON COFFEE ROASTERS CAFE LLC - JUMEIRAH PARK",
  "6544998d77d8fcd5850d09d9": "BOON COFFEE ROASTERS CAFE - PADEL CLUB",
  "68d4fb0fa84663315a09dd58":"BOON COFFEE ROASTERS FZCO - GOLDEN MILE",
  "68d78034c7907180ea01131a":"BOON COFFEE ROASTERS CAFÉ LLC - MEADOWS VILLAGE",
  "68d780b37f315dbe130f4f50":"BOON COFFEE ROASTERS CAFÉ LLC (BRANCH) - FORTE TOWER",
  "68d7815745ea495cf303c17b":"BOON PRODUCTION KITCHEN",
  "6921cc5aa537d69a4103aabb": "Dubai Hills"
};
export default STORE_NAMES;
// utils/getStoreFromUrl.js

//688b8cbab2056ab08208c7b1